import { computed, Injectable } from '@angular/core';
import { AuthFacade } from '@cpd-app/state/auth';
import { toSignal } from '@angular/core/rxjs-interop';
import { UserProfileFacade } from '@cpd-app/state/user-profile';

@Injectable({
  providedIn: 'root'
})
export class ShareProfileService {
  private readonly shareToken = toSignal(this.authFacade.shareToken$);
  private readonly shareProfile = toSignal(
    this.profileFacade.userShareProfile$
  );

  public readonly bannerTitle = computed(
    () => this.shareProfile()?.userEmail || this.shareToken()
  );

  public readonly isShareUserAuthenticated = computed(
    () => !!this.shareProfile()?.userEmail
  );

  constructor(
    private readonly authFacade: AuthFacade,
    private readonly profileFacade: UserProfileFacade
  ) {}
}
